<script>
  // import * as Sentry from "@sentry/sveltekit";
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";
  import Form from "$lib/components/Form/Form.svelte";
  import Icon from "$lib/components/Icon.svelte";
  import Markdown from "$lib/components/Markdown.svelte";
  import { postToSalesforce } from "$lib/utilities";
  import { getContext } from "svelte";
  import { listCampaignIdsFromState } from "$lib/utilities/formFields";
  export let data;
  export let forceVerticalAlignment = false;
  export let description;
  export let selectedNewsletters = getContext("selectedNewsletters");
  export let buttonVariant = "ghost";
  export let noCampaignErrorMessage = "";

  /* 
   the main newsletter signup form is always rendered in the footer
   so some fields with the same `name` property might exist twice on a page.

   we add a form-level instance ID to ensure that form controls
    and labels only apply to their own form instance. 
  */
  const formInstanceId = new Date().getTime().toString(36);

  const fields = data.fields || data;
  let submitted = false;
  let isSubmitting = false;

  let title = data.internalTitle ? data.internalTitle.replace(/\s/g, "") : "other";

  // Eventually, we should create and manage this form field configuration in contentful
  const horizontalFormFields = [
    {
      fieldType: "textInputField",
      fieldProps: {
        type: "text",
        id: `firstName-${fields.campaignId}-${formInstanceId}`,
        label: fields.firstNameLabel,
        name: "first-name",
        required: true,
        autoComplete: "given-name",
        errorMessage: fields.firstNameError
      },
      fieldClass: "w-[248px]"
    },
    {
      fieldType: "textInputField",
      fieldProps: {
        type: "text",
        id: `lastName-${fields.campaignId}-${formInstanceId}`,
        label: fields.lastNameLabel,
        name: "last-name",
        required: true,
        autoComplete: "family-name",
        errorMessage: fields.lastNameError
      },
      fieldClass: "w-[248px]"
    },
    {
      fieldType: "textInputField",
      fieldProps: {
        type: "email",
        id: `email-${fields.campaignId}-${formInstanceId}`,
        label: fields.emailAddressFieldLabel,
        name: "email-address",
        required: true,
        autoComplete: "email",
        errorMessage: fields.emailAddressError
      },
      fieldClass: "w-[248px]"
    }
  ];
  const verticalFormFields = [
    {
      fieldType: "checkboxField",
      fieldProps: {
        type: "checkbox",
        id: `checkbox-${fields.campaignId}-${formInstanceId}`,
        label: fields.termsOfServiceCheckboxLabelMarkdown,
        name: "terms-of-service",
        required: true,
        errorMessage: fields.termsOfServiceError,
        fieldDetailsRichText: fields.termsOfServiceLink
      }
    }
  ];
  let errored;

  async function handleSubmit(ev) {
    const formValues = ev.detail;
    let campaignIds = $selectedNewsletters
      ? listCampaignIdsFromState($selectedNewsletters)
      : fields.campaignId;
    if (campaignIds.length === 0) {
      // No campaignIds selected or protected
      errored = noCampaignErrorMessage;
      return;
    }
    try {
      isSubmitting = true;
      await postToSalesforce({
        pageUrl: $page.url.href,
        campaignIDs: campaignIds,
        firstname: formValues["first-name"],
        lastname: formValues["last-name"],
        email: formValues["email-address"]
      });
      submitted = true;
      description = "";
    } catch (err) {
      errored = err.message;
      // Sentry.captureException(err);
    } finally {
      isSubmitting = false;
    }
  }
</script>

<div aria-live="polite">
  {#if submitted}
    <Markdown input={fields.successMessageMarkdown} />
  {:else}
    <div class="flex flex-col gap-16">
      {#if errored}
        <strong
          class="text-red-700 flex flex-row justify-start items-center gap-8"
          id="gtmEmailSignUpError-{title}"
        >
          <Icon type="error" size="sm" />
          <span>
            {errored}
          </span>
        </strong>
      {/if}

      <Form
        formId="email-signup"
        formFields={[
          {
            orientation: forceVerticalAlignment ? "vertical" : "horizontal",
            fields: horizontalFormFields
          },
          { orientation: "vertical", fields: verticalFormFields }
        ]}
        isLoading={isSubmitting}
        buttonText={isSubmitting ? "please wait." : fields.submitButtonText}
        buttonBelow={true}
        disable={isSubmitting}
        uniqueId="gtmEmailSignUp-{title}"
        {buttonVariant}
        on:submit={handleSubmit}
      />
    </div>
  {/if}
</div>
